import { InformationActions } from "~/apps/shared/actions/consts";

type InformationUIState = {
  loading: boolean;
  errorMessage: string;
}

type InformationState = {
  entities: {};
  ui: InformationUIState;
}

export function information(
  state = {
    entities: {},
    ui: { loading: false, errorMessage: '' }
  } as InformationState, action) {
  switch (action.type) {
    case InformationActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case InformationActions.LOAD_SUCCESS:
      const appUrl = action.appUrl;
      const paymentTypes = action.paymentTypes;
      const features = action.features;

      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        },
        entities: {
          ...state.entities,
          appUrl,
          paymentTypes,
          features,
        }
      };
    case InformationActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    default:
      return state;
  }
}
